module.exports = __webpack_public_path__ + "static/media/TUIsmile.b097f5d9.svg";